export default { component: LoadingComponent, layout: LoadingLayout };

function LoadingComponent() {
  // Applies on a component-level
  return <div>Loading section...</div>;
}

function LoadingLayout() {
  // Applies to the page and all layouts
  return <></>;
}
